/**
 * 絞り込みの現場から、選択できない現場を取り除く。
 *
 * @param selectablePlaceNodeUuids 空配列は未取得として扱い、絞り込みを変更しない
 */
export const dropInaccessiblePlaceNodeUuids = (
  placeNodeUuids: string[],
  selectablePlaceNodeUuids: string[],
): string[] => {
  if (selectablePlaceNodeUuids.length === 0) {
    return placeNodeUuids
  }
  return placeNodeUuids.filter(uuid => selectablePlaceNodeUuids.includes(uuid))
}
